import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_receptionService: {
         extensions: {
            calendar: {
               appointment: {
                  table: {
                     cells: {
                        estimatedDuration: '{{total}} min',
                     },
                     errors: {
                        loadData: 'Wystąpił błąd pobierania danych usług recepcyjnych.',
                     },
                     headers: {
                        advancePayment: 'Przedpłata',
                        estimatedDuration: 'Czas trwania',
                        price: 'Cena',
                        services: 'Usługi',
                     },
                     selector: {
                        label: 'Usługi recepcyjne',
                        noReceptionServicesAssigned: 'Brak dodanych usług dla tego specjalisty',
                        placeholder: {
                           accusative: 'usługi',
                           genitive: 'usług',
                           plural: 'usług',
                        },
                     },
                     summary: {
                        advancePayment: '{{total}} zł',
                        estimatedDuration: '{{total}} min',
                        label: 'Suma:',
                        price: '{{total}} zł',
                     },
                  },
               },
               receptionServiceList: {
                  heading: 'Usługi recepcyjne',
                  placeholder: 'nie wybrano',
               },
            },
            visitHeader: {
               receptionServicesDetail: {
                  label: 'Usługi recepcyjne',
                  placeholder: 'nie wybrano',
               },
            },
         },
      },
   },
};

export const receptionServiceTranslationKeys = createScopedTranslationKeys(translations.pl, 'visit_receptionService');
